var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"fill-background","x":"1.2","y":"1.2","width":"11.2","height":"8.8","key":0}),React.createElement("rect",{"className":"fill-foreground","x":"3.8","y":"3.8","width":"1.2","height":"3.8","key":1}),React.createElement("path",{"className":"fill-foreground","d":"M0,0v10h1.2V1.2h6.2V10H1.2v1.2h12.5V0H0z M12.5,10H10V1.2h2.5V10z","key":2})]);
}

Logo.defaultProps = {"version":"1.0","width":"13.8px","height":"11.2px","viewBox":"0 0 13.8 11.2"};

module.exports = Logo;

Logo.default = Logo;
